module.exports = __webpack_public_path__ + "01f53ef978fe83ca3bf6e8cdb3fdc0f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Characters/pig.png
// module id = 638
// module chunks = 0